<template>
  <q-card>
    <q-table
        row-key="id"
        :rows="data"
        :columns="columns"
        :v-model:pagination="{ page: 1, rowsPerPage: 250, totalRowsNumber: data.length }"
        :rows-per-page-options="[]"
        table-header-class="d-none"
        virtual-scroll
        binary-state-sort
        flat
    >
      <template v-slot:body="props">
        <q-tr
            :props="props"
            :class="{ clickable: selectable }"
            :aria-disabled="!selectable"
            @click="handleClick(props.row)"
        >
          <q-td
              key="details"
              :props="props"
          >
            <div class="text-h6 text-center q-pa-sm shadow rounded">
              <div class="col q-px-sm text-caption text-capitalize">
                {{ props.row.type }}
              </div>

              <div >
                <div class="text-subtitle2 text-bold">
                  {{ props.row.name }}
                </div>

                <div class="text-subtitle2 text-bold">
                  {{ props.row.id }}
                </div>
              </div>

            </div>
          </q-td>
        </q-tr>
      </template>
    </q-table>
  </q-card>
</template>

<script>
import {
  createWarehouseSelectionEvent,
  isWarehouseSelectionEnabled
} from './warehouse-selection.js'

export default {
  name: 'WarehousesCollection',
  emits: ['click'],
  props: {
    data: {
      type: Array,
      default () {
        return []
      }
    },
    rawData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      filter: '',
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 25,
        rowsNumber: 25
      },
      columns: [
        {
          label: '',
          name: 'details',
          align: 'left'
        }
      ],
      stateColors: {
        new: 'info',
        confirmed: 'yellow',
        complete: 'success',
        checking: 'warning',
        deleted: 'danger',
        preset: 'warning',
        archived: 'dark'
      }
    }
  },
  computed: {
    selectable () {
      return isWarehouseSelectionEnabled(this.rawData)
    },
    title () {
      if (this.rawData.options) {
        return this.rawData.options.title
      }

      return this.rawData.title || ''
    }
  },
  methods: {
    handleClick (data) {
      if (!this.selectable) {
        return
      }

      this.$emit('click', createWarehouseSelectionEvent(data))
    }
  }
}
</script>
